import { render, staticRenderFns } from "./CreateBASTBalikan.vue?vue&type=template&id=0ba8ba37&"
import script from "./CreateBASTBalikan.vue?vue&type=script&lang=ts&"
export * from "./CreateBASTBalikan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ba8ba37')) {
      api.createRecord('0ba8ba37', component.options)
    } else {
      api.reload('0ba8ba37', component.options)
    }
    module.hot.accept("./CreateBASTBalikan.vue?vue&type=template&id=0ba8ba37&", function () {
      api.rerender('0ba8ba37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/berita-acara/ba-serah-terima/CreateBASTBalikan.vue"
export default component.exports